import React, { useEffect, useState } from 'react'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import AddPermitView from './components/AddPermitView'

const AddPermit = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('case-payment-information', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <AddPermitView setIsError={setIsError} />
}

export default withTranslation('common')(AddPermit)
